export const OPEN_PASSWORD_RECOVERY_EVENT = 'open-password-recovery'

export const openPasswordRecoveryModal = (): void => {
  window.dispatchEvent(new Event(OPEN_PASSWORD_RECOVERY_EVENT))
}
